
<div
  class="lobby-table-game-specific-wrapper lobbyTableGameSpecificWrapper--3fAEk desktop--1Txr1"
  data-role="lobby-table-game-specific-wrapper"
>
  <ol class="TableGameMegaball--3FxHn" data-role="megaball-history">
    <template v-for="(result, index) in resultsSlice">
      <li
        v-if="result.length == 1"
        :key="index"
        class="Multiplier--3fr5O"
        :style="
          'background: ' +
          getCouleurFill(index, result[0].multiplier) +
          '; border: 1px solid ' +
          getCouleurStroke(result[0].multiplier) +
          ';'
        "
      >
        <div class="ShadowContainer--1cONb">
          <div class="Shadow--1rJqK"></div>
        </div>
        <div class="Text--1WC8k">{{ result[0].multiplier }}x</div>
      </li>
      <!-- <div v-else :key="index" class="Doubleball--22hor">
        <li
          v-for="(resultDouble, index2) in result"
          :key="index2"
          class="Multiplier--3fr5O"
          :style="
            'background: ' +
            getCouleurFill(index, resultDouble.multiplier) +
            '; border: 1px solid ' +
            getCouleurStroke(resultDouble.multiplier) +
            ';'
          "
        >
          <div class="ShadowContainer--1cONb">
            <div class="Shadow--1rJqK"></div>
          </div>
          <div class="Text--1WC8k">{{ resultDouble.multiplier }}x</div>
        </li>
      </div> -->
    </template>
  </ol>
</div>
